import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import axios from "axios";
import LandingPage from "@/pages/LandingPage";
import BookingPage from "@/pages/BookingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminRegister from "@/pages/AdminRegister";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    axios.post(`${API}/track`).catch(() => {});
  }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-center" theme="light" richColors closeButton />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/bestill" element={<BookingPage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/register" element={<AdminRegister />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
